import { DialogService, MessageType } from 'src/app/features/shared/services/dialog.service';
import { StorageProvider } from '../../storage.provider';
import { openNewTab } from '../../../../app/core/utils';
import { Logger, StorageItem } from '@uploadcam/common';
import { FeaturesService } from '../../../../app/features/shared/services/features.service';
import { StorageEmbeddedEvent } from '../storage-embedded-event';

export class OpenStorageFolderInteractor {
  constructor(
    private readonly dialog: DialogService,
    private readonly features: FeaturesService,
    private readonly logger: Logger,
    private readonly postMessage: (event: StorageEmbeddedEvent) => void,
    private readonly provider: StorageProvider,
  ) {}

  public async execute(folder: StorageItem): Promise<void> {
    const closeFn = this.dialog.wait();

    try {
      const manager = await this.provider.provideManager();
      const url = await manager.getFolderUrl(folder);

      if (this.features.context().isEmbedded) {
        this.postMessage({ type: 'storage-open-folder', folder });
      } else {
        openNewTab(url);
      }
    } catch (err) {
      this.logger.error(err);
      this.dialog.snack('Failed to open the folder', MessageType.Error);
    } finally {
      closeFn();
    }
  }
}
